import { BaseUnits } from "uom";
import * as UnitTimes from "../unit-times";
import { KiloWatt, MegaWatt, GigaWatt, Watt } from "./power";
import { Hour } from "./duration";
// These units have a dependency on power, but power has a dependency on energy so we need a separate module for them.
export var KiloWattHour = UnitTimes.powerByDuration("KiloWattHour", KiloWatt, Hour);
export var MegaWattHour = UnitTimes.powerByDuration("MegaWattHour", MegaWatt, Hour);
export var GigaWattHour = UnitTimes.powerByDuration("GigaWattHour", GigaWatt, Hour);
export var WattHour = UnitTimes.powerByDuration("WattHour", Watt, Hour);
export var WattSecond = UnitTimes.powerByDuration("WattSecond", Watt, BaseUnits.Second);
//# sourceMappingURL=energy2.js.map